import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import ContextMenu from 'components/global/ContextMenu';
import { Badge } from 'react-bootstrap';
import { formatMoneyShorthand } from 'utils/formatMoney';
import { faLink, faUnlink } from '@fortawesome/free-solid-svg-icons';
import { $detail } from 'signals/global.signals';
import PipelineStatusBadge from 'components/global/PipelineStatusBadge';

const FounderDealPipelineRow = ({ data }) => data?.map((pipelineItem) => {
  const investor = pipelineItem.organization;
  return ({
    ...pipelineItem,
    name: <span className="fw-bold">{investor.name}</span>,
    PipelineStatus: <PipelineStatusBadge status={pipelineItem.pipelineStatus} />,
    email: investor.email,
    investorType: investor.investorType,
    committed: formatMoneyShorthand(pipelineItem.previouslyCommitted),
    invested: formatMoneyShorthand(pipelineItem.amountInvested),
    // invested: `${formatMoneyShorthand(pipelineItem.amountInvested)} / ${formatMoneyShorthand(pipelineItem.previouslyCommitted)}`,
    Actions: () => (
      <div className="d-flex align-items-center">
        <Badge bg="gray-800" className="text-info fw-normal rounded-pill border-gray-900">
          <FontAwesomeIcon
            icon={pipelineItem.recordType === 'synced' ? faLink : faUnlink}
            className={investor.recordType === 'synced' ? 'text-success' : 'text-gray-700'}
            size="sm"
          />
        </Badge>
        <ContextMenu
          menuItems={[
            {
              label: 'Edit',
              onClick: () => handleShowModal('founder-deal-edit-pipeline', {
                pipelineId: pipelineItem.id,
                amountInvested: pipelineItem.amountInvested,
                previouslyCommitted: pipelineItem.previouslyCommitted,
                dealName: $detail.value?.name,
                investorName: pipelineItem.organization.name,
                pipelineStatus: pipelineItem.pipelineStatus,
              }),
            },
            {
              label: 'Remove from Deal',
              onClick: () => {
                handleShowModal('founder-deal-remove-investor', { ...pipelineItem, dealName: $detail.value?.name, id: pipelineItem.id });
              },
            },
          ]}
        />
      </div>
    ),
  });
});

export default FounderDealPipelineRow;
